import { all, call, put, takeLatest } from 'redux-saga/effects'
import { setOfficeHour, setShowWidget, setWidgetInfo } from './widget.actions'
import { createWidgetInfoObject } from './widget.adapter'
import { handleFetchWidgetInfo } from './widget.helper'
import { widgetTypes } from './widget.types'
// import * as Sentry from '@sentry/react'

export function* fetchWidgetInfo() {
  try {
    const returnedData = yield handleFetchWidgetInfo()

    if (returnedData.statusCode === 200) {
      let widgetInfoObject = yield createWidgetInfoObject(returnedData.data)

      yield put(
        setWidgetInfo({
          data: widgetInfoObject.data,
          languageInfo: widgetInfoObject.languageInfo,
          faq: widgetInfoObject.faq,
        }),
      )

      yield put(setShowWidget(widgetInfoObject.showWidget))
      yield put(setOfficeHour(widgetInfoObject.isOfficeHour))

      return {
        status: true,
        data: widgetInfoObject.data,
      }
    } else if (returnedData.statusCode && (returnedData.statusCode === 403 || returnedData.statusCode === 204)) {
      yield put(setShowWidget(false))
      return {
        status: false,
      }
    }
  } catch (error) {
    console.log(error)
    // Sentry.captureMessage(error, 'error')
  }
}

function* onFetchWidgetInfoStart() {
  yield takeLatest(widgetTypes.FETCH_WIDGET_INFO_START, fetchWidgetInfo)
}

export default function* widgetSagas() {
  yield all([call(onFetchWidgetInfoStart)])
}
